import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
const DUE_DATE_REQUEST_TIMEOUT = 15000;
const inFlightRequests = new Map();

export const getDueDateReportServices = (request) => {
  const key = JSON.stringify(request);
  if (inFlightRequests.has(key)) return inFlightRequests.get(key);

  const promise = (async () => {
    try {
      const token = Cookies.get("Bearer");
      const response = await axios.put(
        `${FIRMFLOWURL}api/Analytics/dueDateReport/services`,
        {
          ...request,
        },
        {
          headers: { Authorization: token },
          params: { includeInactive: Boolean(request.includeInactive) },
          timeout: DUE_DATE_REQUEST_TIMEOUT,
        }
      );
      return { ...response, success: true };
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        Cookies.remove("Bearer");
        window.location.replace("/");
      }
      return {
        success: false,
        status,
        message: err.response?.data?.message || err.message || "Request failed.",
      };
    }
  })().finally(() => inFlightRequests.delete(key));
  inFlightRequests.set(key, promise);
  return promise;
};
